import { render, staticRenderFns } from "./OnlineBroadcastPage.vue?vue&type=template&id=e4999ada&scoped=true&"
import script from "./OnlineBroadcastPage.vue?vue&type=script&lang=js&"
export * from "./OnlineBroadcastPage.vue?vue&type=script&lang=js&"
import style0 from "./OnlineBroadcastPage.vue?vue&type=style&index=0&id=e4999ada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4999ada",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4999ada')) {
      api.createRecord('e4999ada', component.options)
    } else {
      api.reload('e4999ada', component.options)
    }
    module.hot.accept("./OnlineBroadcastPage.vue?vue&type=template&id=e4999ada&scoped=true&", function () {
      api.rerender('e4999ada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OnlineBroadcastPage.vue"
export default component.exports